export default __webpack_public_path__ + "static/media/zoomout_PC.bcba851a.svg";